import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import {
  buildStocktakeDetailLineColumns,
} from '#/modules/imsMgmt/receipts/stocktake/columns/stocktakeDetailLineColumns';

/** 依後端 lines[] 陣列序顯示；不重排、不顯示系統量。 */
const StocktakeLinesTable = ({ lines = [] }) => {
  const columns = useMemo(() => buildStocktakeDetailLineColumns(), []);

  const rows = useMemo(
    () => (lines ?? []).map((line, index) => ({
      ...line,
      id: line.inventoryStock?.id
        ? `${line.inventoryStock.id}-${index}`
        : `line-${index}`,
    })),
    [lines],
  );

  const detailTableState = useDetailTable(rows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
      />
    </div>
  );
};

StocktakeLinesTable.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
};

export default StocktakeLinesTable;
